<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import { computed } from 'vue';
import type { FeatureFlag } from '@/types/models';
import { useFeatureFlags } from '@/composables/featureFlags';

const { featureFlags, match = 'all' } = defineProps<{
    featureFlags: FeatureFlag | FeatureFlag[];
    match?: 'all' | 'any';
}>();

const { hasFeatureFlags } = useFeatureFlags();

const isFeatureEnabled = computed(() => hasFeatureFlags(featureFlags, match));
</script>

<template>
    <slot :name="isFeatureEnabled ? 'default' : 'disabled'" />
</template>
